const Fields = {
  name: "Nombre",
  task: "Tarea",
  tasks: "Tareas",
};

export default Fields;
